import { CONTENT } from "../config";

export function renderOverlay() {
  const app = document.getElementById("app");
  if (!app) return;

  app.innerHTML = `
    <!-- Hero Section -->
    <section class="hero">
      <div class="hero-content">
        <div class="hero-avatar">
          <img src="/resources/avatar.png" alt="Grzegorz Gajos" class="avatar-image" />
        </div>
        <div class="identity">${CONTENT.identity}</div>
        <h1 class="hero-title">${CONTENT.hero.firstName} ${
          CONTENT.hero.lastName
        }</h1>
        <p class="hero-subtitle">${CONTENT.hero.subtitle}</p>
        <div class="hero-actions">
          <a href="#contact" class="btn btn-primary">Initialize Connection</a>
          <a href="#timeline" class="btn btn-secondary">Mission Log</a>
        </div>
      </div>
    </section>

    <!-- Panels Section -->
    <section class="panels">
      ${CONTENT.panels
        .map(
          (panel) => `
        <div class="panel">
          <div class="panel-header">
            <h3 class="panel-title">${panel.header}</h3>
          </div>
          <p class="panel-text">${panel.content}</p>
        </div>
      `
        )
        .join("")}
    </section>

    <!-- Stats Section -->
    <section class="stats">
      ${CONTENT.stats
        .map(
          (stat) => `
        <div class="stat-card">
          <div class="stat-value">${stat.number}</div>
          <div class="stat-label">${stat.label}</div>
        </div>
      `
        )
        .join("")}
    </section>

    <!-- Technology Arsenal -->
    <section class="tech-arsenal">
      <h2 class="section-title">Primary Arsenal</h2>
      <div class="arsenal-container">
        ${Object.entries(CONTENT.technologies)
          .map(
            ([category, techs]) => `
          <div class="arsenal-cluster" data-category="${category}">
            <div class="cluster-label">${category}</div>
            <div class="cluster-items">
              ${techs
                .map(
                  (tech: any) => `
                <span class="tech-badge" data-level="${tech.level}" style="--tech-level: ${tech.level}">
                  ${tech.name}
                </span>
              `
                )
                .join("")}
            </div>
          </div>
        `
          )
          .join("")}
      </div>
    </section>

    <!-- Timeline Section -->
    <section id="timeline" class="timeline">
      <h2 class="section-title">Mission Log</h2>
      <div class="timeline-track">
        ${CONTENT.timeline
          .map(
            (entry: any, index: number) => `
          <div class="timeline-item">
            <div class="timeline-marker"></div>
            <div class="timeline-content">
              <div class="timeline-year">${entry.year}</div>
              <div class="timeline-title">${entry.role} — ${entry.company}</div>
              <div class="timeline-text">${entry.description}</div>
              ${
                entry.projects && entry.projects.length > 0
                  ? `
                <button class="timeline-expand-btn" data-timeline-index="${index}">
                  <span class="expand-icon">▸</span> View Projects (${
                    entry.projects.length
                  })
                </button>
                <div class="timeline-projects" data-timeline-index="${index}" style="display: none;">
                  ${entry.projects
                    .map(
                      (project: any) => `
                    <div class="project-card">
                      <div class="project-header">
                        <span class="project-name">${project.name}</span>
                        ${
                          project.role
                            ? `<span class="project-role">${project.role}</span>`
                            : ""
                        }
                      </div>
                      <div class="project-description">${
                        project.description
                      }</div>
                      <div class="project-tech">${project.tech}</div>
                    </div>
                  `
                    )
                    .join("")}
                </div>
              `
                  : ""
              }
            </div>
          </div>
        `
          )
          .join("")}
      </div>
    </section>

    <!-- Contact Terminal -->
    <section id="contact" class="contact">
      <h2 class="section-title">${CONTENT.contact.title}</h2>
      <div class="terminal">
        <div class="terminal-header">
          <span class="terminal-prompt">$ contact --establish-link</span>
        </div>
        <div class="terminal-body">
          ${CONTENT.contact.links
            .map(
              (link: any) => `
            <a href="${link.href}" target="${
              link.target || "_self"
            }" rel="noopener" class="terminal-link">
              <span class="terminal-label">${link.label}</span>
              <span class="terminal-arrow">→</span>
            </a>
          `
            )
            .join("")}
        </div>
      </div>
    </section>
  `;

  // Add event listeners for timeline expand buttons
  setTimeout(() => {
    const expandButtons = document.querySelectorAll(".timeline-expand-btn");
    expandButtons.forEach((button) => {
      button.addEventListener("click", (e) => {
        const btn = e.currentTarget as HTMLElement;
        const index = btn.getAttribute("data-timeline-index");
        const projectsDiv = document.querySelector(
          `.timeline-projects[data-timeline-index="${index}"]`
        ) as HTMLElement;
        const icon = btn.querySelector(".expand-icon");

        if (projectsDiv) {
          const isExpanded = projectsDiv.style.display !== "none";
          projectsDiv.style.display = isExpanded ? "none" : "block";
          if (icon) {
            icon.textContent = isExpanded ? "▸" : "▾";
          }
        }
      });
    });
  }, 100);
}
